import React from "react";
import Status, { StatusUrl } from "../../Status";
import MeganavBlog, { BlogPost } from "../MeganavBlog";
import MeganavCustomerStories from "../MeganavCustomerStories";
import { MeganavPanel, MeganavPanelFullwidth } from "../MeganavPanel";
import {
  ablyAwards,
  companyMenu,
  compareMenu,
  customerStoriesHighlight,
  MenuItem,
  productsMenu,
  solutionsMenu,
  menuItemLinks,
  defaultBlogPosts,
} from "../data";

export const getMenuItemsForHeader = (blogPosts: BlogPost[]): MenuItem[] => {
  const panelClassName = "w-full sm:w-[50.9375rem]";
  const recentBlogPosts =
    blogPosts?.length > 0 ? blogPosts.slice(0, 2) : defaultBlogPosts;

  return [
    {
      name: "Products",
      content: (
        <MeganavPanel
          displayProductTile={true}
          panelRightItems={[
            { label: "Platform", listItems: productsMenu },
            {
              link: { label: "Compare our tech", link: "/compare" },
              listItems: compareMenu,
            },
          ]}
          panelRightBottom={
            <Status
              statusUrl={StatusUrl}
              additionalCSS="px-3 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-1200 active:bg-neutral-200 dark:active:bg-neutral-1100 rounded-lg"
              showDescription
            />
          }
        />
      ),
      panelClassName,
    },
    {
      name: "Solutions",
      content: <MeganavPanelFullwidth panelItems={solutionsMenu} />,
      panelClassName,
    },
    {
      name: "Company",
      content: (
        <MeganavPanel
          panelLeft={
            <MeganavCustomerStories
              title="Customer stories"
              link="/case-studies"
              icon="icon-gui-rocket-launch-outline"
              customerStoriesHighlight={customerStoriesHighlight}
            />
          }
          panelMiddleItems={
            <MeganavBlog
              title="Blog"
              link="/blog"
              posts={recentBlogPosts}
              icon="icon-gui-light-bulb-outline"
            />
          }
          panelRightItems={[
            {
              label: "Ably",
              listItems: companyMenu,
              displayTitleInMobile: false,
            },
          ]}
          panelRightBottom={
            <div className="flex-1 gap-x-2 hidden md:flex p-3">
              {ablyAwards.slice(0, 3).map((award) => (
                <img
                  key={award.desc}
                  src={award.image}
                  alt={award.desc}
                  width="57"
                  height="64"
                  loading="lazy"
                />
              ))}
            </div>
          }
          panelRightBottomClassName="hidden md:flex"
        />
      ),
      panelClassName,
    },
    ...menuItemLinks,
  ];
};
